import { dataMember, required, typedArray } from 'santee-dcts';
import { deserializers } from '../../../core';
import { ActivityReport, Distance } from '../../../shared';
import * as moment from 'moment';
import { EQueryStatus } from '../../../e-queries/models/e-query-status';
import { siteDisplayNameRenderer } from '../../../renderer/site-display-name-renderer';

export class ActivityReportEQuery extends ActivityReport {
    @required()
    @dataMember()
    public eQueryId: number;

    @required({ nullable: true })
    @dataMember()      
    public sponsorName: string;

    @required({ nullable: true })
    @dataMember()  
    public protocolName: string;

    @required({ nullable: true })
    @dataMember()  
    public zcProjectNumber: string;

    @required({ nullable: true })
    @dataMember()  
    public siteName: string;

    @required({ nullable: true })
    @dataMember() 
    public siteNum: string;

    @required({ nullable: true })
    @dataMember() 
    public country: string;

    @required({ nullable: true })
    @dataMember() 
    public visit: string;

    @required({ nullable: true })
    @dataMember({ customDeserializer: deserializers.deserializeDate })
    public visitCollectionDate: moment.Moment;

    @required({ nullable: true })
    @dataMember() 
    public accessionNumber: string;

    @required({ nullable: true })
    @dataMember() 
    public zcSubjectId: string;

    @required({ nullable: true })
    @dataMember() 
    public subjectNumber: string;

    @required({ nullable: true })
    @dataMember() 
    public subjectInitials: string;

    @required()
    @dataMember()
    public eQueryAge: Distance;

    @required({ nullable: true })
    @dataMember()
    public responseAge: Distance;

    @required()
    @dataMember()
    public status: EQueryStatus;

    @required()
    @dataMember({ customDeserializer: deserializers.deserializeDate })
    public createDate: moment.Moment;

    @required({ nullable: true })
    @dataMember({ customDeserializer: deserializers.deserializeDate })
    public responseDate: moment.Moment;

    @required({ nullable: true })
    @dataMember() 
    public userName: string;

    @required({ nullable: true })
    @dataMember() 
    public studyRole: string;

    @required({ nullable: true })
    @dataMember() 
    public email: string;

    @required()
    @dataMember()
    public issueTypes: string;

    public get siteDisplayName(): string {
        return siteDisplayNameRenderer({siteNumber: this.siteNum, investigatorFullName: this.siteName});
    }
}

export class ActivityReportEQueriesReadModel {
    @dataMember()
    @required()
    @typedArray(ActivityReportEQuery)
    public activityReports: ActivityReportEQuery[];
}
